import { createTheme } from '@material-ui/core/styles'

export const numberTheme = createTheme({
  overrides: {
    MuiInputBase: {
      input: {
        fontSize: '14px',
      },
    },
  },
})

export const currencyTheme = createTheme({
  overrides: {
    MuiInputBase: {
      input: {
        fontSize: '14px',
        textAlign: 'end',
      },
    },
  },
})
